import { Controller } from "@hotwired/stimulus"

// Tabs that show one panel at a time without a request. The last tab picked is remembered (per
// storage key) so moving to the next listing in the drawer keeps you on the same tab.
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { storageKey: String }
  static classes = ["active"]

  connect() {
    const remembered = this.storageKeyValue && sessionStorage.getItem(this.storageKeyValue)
    const invalid = this.panelTargets.find((panel) => panel.querySelector("[aria-invalid=true], .field_with_errors"))
    const name = invalid?.dataset.tabName || (this.tabTargets.some((tab) => tab.dataset.tabName === remembered) ? remembered : this.tabTargets[0]?.dataset.tabName)
    if (name) this.show(name)
  }

  select(event) {
    event.preventDefault()
    const name = event.currentTarget.dataset.tabName
    this.show(name)
    if (this.storageKeyValue) sessionStorage.setItem(this.storageKeyValue, name)
  }

  show(name) {
    const activeClass = this.hasActiveClass ? this.activeClass : "ui-utab-active"
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tabName === name
      tab.classList.toggle(activeClass, active)
      tab.setAttribute("aria-selected", active)
      tab.tabIndex = active ? 0 : -1
    })
    this.panelTargets.forEach((panel) => (panel.hidden = panel.dataset.tabName !== name))
  }
}
